import {
    Alert,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl, FormControlLabel,
    FormHelperText, FormLabel, InputAdornment, Tooltip
} from "@mui/material";
import MDInput from "../../components/MDInput";
import React, {useEffect, useState} from "react";
import Button from "@mui/material/Button";
import MDButton from "../../components/MDButton";
import MDTypography from "../../components/MDTypography";
import MDBox from "../../components/MDBox";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import Grid from "@mui/material/Grid";
import FramerFade from "../../components/Animation/Fade";
import Icon from "@mui/material/Icon";
import PlacesAutocomplete, {geocodeByAddress} from "react-places-autocomplete";
import {getVerificationCode, Logout, onErrorAlert, onSuccessAlert} from "../../actions";
import {useDispatch, useSelector} from "react-redux";
import MuiPhoneNumber from 'material-ui-phone-number';
import Checkbox from "@mui/material/Checkbox";
import { v4 as uuidv4 } from 'uuid';
import {
    addCustomerAddress,
    customerInfo,
    editCustomer,
    editCustomerAddress
} from "../../actions/customer/customerAction";
import {noop} from "lodash";
import {useNavigate} from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import {countriesForAddress, countriesForAddressCN, countriesForAddressFR} from "../../constants";
import IconButton from "@mui/material/IconButton";
import InfoIcon from '@mui/icons-material/Info';
import {useTranslation} from "react-i18next";
import {getAreaCodeList, ownerSelected} from "../../actions/inventory/inventoryAction";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import LocalStorage from "../../utils/LocalStorage";
const AddressAdd = ({isAddressOpen,setIsAddressOpen,addresses,setAddresses,currentAddress = {},setCurrentAddress,mode,setMode,customerId,ownerId,customerName,type,data,onInfoSuccess}) => {
    const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
    const [address,setAddress] = useState('')
    const [countriesForAddressList,setCountriesForAddressList] = useState([])
    const [cityValue,setCityValue] = useState('')
    const [provinceValue,setProvinceValue] = useState('')
    const [postcodeValue,setPostcodeValue] = useState('')
    const [countryValue,setCountryValue] = useState('')
    const [countryObj,setCountryObj] = useState(null)
    const addressFilter = ['address']
    const areaCodeList = useSelector(state => state?.inventory?.areaCodeList,(prev, next) => prev === next)
    const languageSelect = useSelector(state => state?.common?.language,(prev, next) => prev === next)
    const [hoverSelect,setHoverSelect] = useState(false)
    const [activeStep,setActiveStep] = useState(0)
    const [isDefault,setIsDefault] = useState(false)
    const [closeWarning, setCloseWarning] = useState(false)
    const [phone,setPhone] = useState('')
    const dispatch = useDispatch()
    const nav = useNavigate()
    const {t} = useTranslation()
    const schema = yup
        .object({
            // fullName: yup.string()
            //     .min(3,t('CustomerPage.Full name must equal or more than 3 characters'))
            //     .max(32,t('CustomerPage.Full name must equal or less than 32 characters'))
            //     .matches(/^[^\s].*[^\s]$/, t('CustomerPage.No leading or trailing spaces allowed.'))
            //     .required(t('Required'))
            // ,
            firstName: yup.string()
                .min(3,t('CustomerPage.First name must equal or more than 3 characters'))
                .max(32,t('CustomerPage.First name must equal or less than 32 characters'))
                // .matches(/^[^\s].*[^\s]$/, t('CustomerPage.No leading or trailing spaces allowed.'))
                // .matches(
                //     /^\S+$/,
                //     t('CustomerPage.First name cannot contain spaces')
                // )
                .matches(
                    /^[^,]*$/,
                    t('CustomerPage.Comma is not allowed')
                )
                .required(t('Required'))
            ,
            lastName: yup.string()
                .min(3,t('CustomerPage.Last name must equal or more than 3 characters'))
                .max(32,t('CustomerPage.Last name must equal or less than 32 characters'))
                .matches(/^[^\s].*[^\s]$/, t('CustomerPage.No leading or trailing spaces allowed.'))
                .matches(
                    /^[^,]*$/,
                    t('CustomerPage.Comma is not allowed')
                )
                .required(t('Required'))
            ,
            // title:yup.string()
            //     .matches(/^[^\s].*[^\s]$/, t('CustomerPage.No leading or trailing spaces allowed.'))
            //     .min(3,t('CustomerPage.Title must equal or more than 3 characters'))
            //     .max(32,t('CustomerPage.Title must equal or less than 32 characters'))
            //     .required(t('Required')),
            phoneNumber:yup.string(),
            email: yup.string().trim().email(t('CustomerPage.Email must be a valid email'))
                // .required(t("Required"))
            ,
            address1:yup.string().trim(),
            city:yup.string().trim()

        })

    const {
        register,
        reset,
        trigger,
        setError,
        handleSubmit,
        getValues,
        setValue,
        clearErrors,
        formState: {errors}
    } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange"
    });

    useEffect(() => {
        const axiosPost = async () => {
            await dispatch(getAreaCodeList())
        }
        axiosPost().then()
    },[])

    useEffect(() => {
        setCountriesForAddressList(areaCodeList)
    },[areaCodeList])
    useEffect(()=>{
        // if(languageSelect === 'zh'){
        //     setCountriesForAddressList(countriesForAddressCN)
        // } else if (languageSelect === 'en'){
        //     setCountriesForAddressList(countriesForAddress)
        // } else if (languageSelect === 'fr'){
        //     setCountriesForAddressList(countriesForAddressFR)
        // }
        setCountriesForAddressList(areaCodeList)
    },[languageSelect])
    const handleClearAll = () => {
        setMode('Add')
        setCurrentAddress({})
        setIsAddressOpen(false)
        setCloseWarning(false)
        reset()
        clearErrors()
        setAddress('')
        setCityValue('')
        setProvinceValue('')
        setPostcodeValue('')
        setCountryValue('')
        setCountryObj(null)
        setIsDefault(false)
        setPhone('')

    }
    const onSubmit = (data) => {
        // if(addresses.find((v)=>v.contactTitle?.trim() === data?.title?.trim()) && mode === 'Add'){
        //
        //     return setError('title',{type: "title", message: t('CustomerPage.This address title already existed, please change another one')})
        // }


        if(address?.trim() ===''){
            return setError("address1",{ type: "address1", message: t('CustomerPage.Address is required') })
        }
        if(cityValue?.trim() === ''){
            return setError("city",{ type: "city", message: t('CustomerPage.City is required') })
        }

        if(provinceValue?.trim() === ''){
            return setError("province",{ type: "province", message: t('CustomerPage.Province is required') })
        }

        if(postcodeValue?.trim() === ''){
            return setError("postcode",{ type: "postcode", message: t('CustomerPage.Postal Code is required') })
        }


        if(!countryObj){
            return setError("countryObj",{ type: "countryObj", message: t('CustomerPage.Country is required') })
        }

        if(phone?.length < 14){
            return  setError("phoneNumber",{ type: "phoneNumber", message: t('CustomerPage.Please input valid phone number') })
        }

        let record = {}

        record.address1 = address?.trim()
        record.address2 = data?.address2?.trim()
        record.city = cityValue?.trim()
        // record.contact = data.fullName?.trim()
        record.contact = data.firstName?.trim() + ',' + data.lastName?.trim()
        // record.country = countryValue?.trim()
        // record.countryCode = countryValue?.trim()

        record.country = countryObj?.value
        record.countryCode = countryObj?.value

        record.contactEmail = data?.email?.trim() || ""
        record.contactFax = data?.fax?.trim()
        record.contactTel1 = phone?.trim()
        record.contactTel2 = data?.phoneNumber2?.trim()
        record.contactTitle = uuidv4()
        record.isDefault = isDefault? "Y" : "N"
        record.province = provinceValue?.trim()
        record.provinceCode = provinceValue?.trim()
        record.remark = data?.remark?.trim()
        record.zipcode = postcodeValue?.trim()
        record.addressId = uuidv4()
        record.ownerId = ownerId
        record.customerId = customerId
        record.customerName = customerName
        let formData = {}
        if(mode !== 'Edit'){
            delete record.addressId
            formData.customerAddressInfo={...record}
            formData.userName = localStorage.getItem('username')
            if (type === 'Add'){
                onAddressAddSuccess(record)
            }else {
                const apiPost = async () => {
                    await dispatch(addCustomerAddress(formData,()=>{
                        dispatch(onSuccessAlert(t("CustomerPage.Add Address Info successfully")))
                        onAddressAddSuccess(record)
                    },onError))
                }
                apiPost().then()
            }


        }

        if(mode === 'Edit'){
            record.addressId = currentAddress.addressId
            record.contactTitle = currentAddress.contactTitle
            formData.customerAddressInfo={...record}
            formData.userName = localStorage.getItem('username')
            if (type === 'Add' || type === 'Copy'){
                onAddressChangeSuccess(record)
            }else {
                const apiPost = async () => {
                    await dispatch(editCustomerAddress(formData,()=>{
                        dispatch(onSuccessAlert(t("CustomerPage.Edit Address Info successfully")))
                        onAddressChangeSuccess(record)
                    },onError))
                }
                apiPost().then()
            }

        }

    }



    const onAddressAddSuccess = (record)=>{
        if(isDefault){
            setAddresses((prev)=>[...prev.map(item => {
                return {
                    ...item,
                    isDefault: 'N'
                };
            }),record])

        } else {
            setAddresses((prev)=>[...prev,record])
        }
        const axiosPost= async () => {
            if(checkPermission(PERMISSION_DICT.QueryOwnerInfo)){
                await dispatch(ownerSelected({condition: data?.ownerId, userName: LocalStorage.getItem('username')}, (data)=>setOwnerId(data[0])))
            }
            let formData = {}
            formData.ownerId = data.ownerId
            formData.userName = data.ownerName
            formData.customerId = data.customerId
            // setLoading(true)
            await dispatch(customerInfo(formData, onInfoSuccess,onError))
        }
        if (type === "Edit"){
            axiosPost().then()
        }
        handleClearAll()
    }

    const onAddressChangeSuccess = (record)=>{
        if(isDefault){
            setAddresses((prev)=> prev.map(item => {
                if (item?.addressId === currentAddress?.addressId) {
                    return record; // 如果找到匹配的对象，替换为新的对象
                } else {
                    return { ...item, isDefault: 'N' };
                }
            }))

        } else {
            setAddresses((prev)=>prev.map(item => {
                if (item?.addressId === currentAddress?.addressId) {
                    return record; // 如果找到匹配的对象，替换为新的对象
                } else {
                    return item; // 否则保持原对象不变
                }
            }))
        }
        handleClearAll()
    }



    const handleSelect = async address => {
        const results = await geocodeByAddress(address)

        let address1 = "";
        let postcode = "";
        let city = '';
        let state = '';
        let country = '';
        for(const component of results[0].address_components){
            const componentType = component.types[0];

            switch (componentType) {
                case "street_number": {
                    address1 = `${component.long_name} ${address1}`;
                    break;
                }

                case "route": {
                    address1 += component.short_name;
                    break;
                }

                case "postal_code": {
                    postcode = `${component.long_name}${postcode}`;
                    break;
                }

                case "postal_code_suffix": {
                    postcode = `${postcode}-${component.long_name}`;
                    break;
                }

                case "locality":
                    city =
                        component.long_name;
                    break;

                case "administrative_area_level_1": {
                    state =
                        component.short_name;
                    break;
                }

                case "country":
                    country =
                        // component.long_name;
                        // component.short_name.toLowerCase();
                        component.short_name
                    break;
            }
        }
        if (address1 !== ""){
            setAddress(address1)
        }

        setCityValue(city)
        setProvinceValue(state)
        setCountryValue(country)
        setCountryObj(countriesForAddressList.find((v)=>v.value === country))
        setPostcodeValue(postcode)
        document.getElementById('address2').focus()
    };

    const handleMouseEnter = (index) => {
        setHoverSelect(index);
    };

    const handleMouseLeave = () => {
        setHoverSelect(-1);
    };

    const findCountry = (currentAddress) =>{
        let res = null
        if (countriesForAddressList.find((v)=>v.value === currentAddress?.country)){
            res = countriesForAddressList.find((v)=>v.value === currentAddress?.country)
        }
        if (countriesForAddressList.find((v)=>v.label === currentAddress?.country)){
            res =  countriesForAddressList.find((v)=>v.label === currentAddress?.country)
        }
        if (countriesForAddressList.find((v)=>v.value === currentAddress?.countryCode)){
            res =  countriesForAddressList.find((v)=>v.value === currentAddress?.countryCode)
        }
        if (countriesForAddressList.find((v)=>v.label === currentAddress?.countryCode)){
            res=  countriesForAddressList.find((v)=>v.label === currentAddress?.countryCode)
        }
        return res;
    }

    useEffect(() => {
        if(mode === 'Edit' || mode === 'Preview'){
            setIsAddressOpen(true)
            // setValue('title',currentAddress?.contactTitle)
            setValue('email',currentAddress?.contactEmail || "")
            // setValue('fullName',currentAddress?.contact)

            const contact = currentAddress?.contact?.trim() || '';
            const [firstName = '', ...rest] = contact.split(',');
            const lastName = rest.join(',').trim();
            setValue('firstName', firstName);
            setValue('lastName', lastName);

            setValue('address2',currentAddress?.address2)
            setValue('phoneNumber2',currentAddress?.contactTel2)
            setValue('fax',currentAddress?.contactFax)
            setValue('remark',currentAddress?.remark)
            setAddress(currentAddress?.address1)
            setCityValue(currentAddress?.city)
            setProvinceValue(currentAddress?.provinceCode)
            setPhone(currentAddress?.contactTel1)
            setCountryValue(currentAddress?.country)
            setCountryObj(findCountry(currentAddress))
            setPostcodeValue(currentAddress?.zipcode)
            setIsDefault(currentAddress?.isDefault === 'Y')


        }
    }, [currentAddress])

    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        // setLoading(false)
        // setPageLoading(false)
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const handleNext = () => {

        if(address === ''){
            setError("address",{ type: 'custom', message: t('CustomerPage.custom message') })
        }


        setActiveStep(1)
    }

    return(<Dialog
        open={isAddressOpen}
        onClose={handleClearAll}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        sx={{
            maxHeight: "100vh", // 限制 Dialog 最大高度
            overflow: "hidden", // 避免外部滚动条
            "& .MuiDialog-paper": {
                maxHeight: "100vh", // 让 Dialog 内部 Paper 也受限
                overflow: "hidden", // 避免不必要的外部滚动条
            },
        }}
    >
        <DialogTitle  style={{cursor: 'move', display: 'flex', justifyContent: 'space-between',position: "sticky",
            alignItems: "center",
            top: 0,
            zIndex: 1100,
            boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px',}}>
            <MDTypography variant={'h5'}>
                {mode === 'Preview' && t("CustomerPage.Address Information")}
                {mode === 'Edit' && t("CustomerPage.Edit Address")}
                {mode === 'Add' && t("CustomerPage.Add New Address")}
            </MDTypography>
        </DialogTitle>
        <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{maxWidth: 1300}}>
            <DialogContent sx={{
                maxHeight: "80vh", // 限制最大高度，防止 Dialog 过长
                overflowY: "auto", // 允许滚动
            }} >
                <DialogContentText
                    id="scroll-dialog-description"
                    tabIndex={-1}
                >
                    <MDBox pt={2} pb={2} px={3} sx={{display: 'flex', justifyContent: 'space-between'}}>
                        <MDBox sx={{display: 'flex', flexDirection:'column',justifyContent: 'space-between'}}>
                            <Grid textAlign='center'>
                                <Icon style={darkMode?{color:'white'}:{color:'text'}}  fontSize={'large'}>account_circle</Icon></Grid>
                            <MDTypography variant={'h5'} align="center">{t('CustomerPage.Address Information')}</MDTypography>
                            {
                                mode !== 'Preview' &&
                                <MDBox mt={2} mb={2} sx={closeWarning ? { display: 'none' } : {}}>
                                    <Alert severity="warning" onClose={() => setCloseWarning(true)}>
                                        {t('CustomerPage.The auto-filled address is generated in a format recognized by Google Maps. Please review and adjust the address if any information is missing or inaccurate.')}
                                    </Alert>
                                </MDBox>
                            }
                            {/*<MDBox mb={2}>*/}
                            {/*    <FormControl*/}
                            {/*        error = {!!errors.title}*/}
                            {/*        fullWidth*/}
                            {/*        focused = {true}*/}
                            {/*    >*/}
                            {/*        <MDInput*/}
                            {/*            inputProps={{*/}
                            {/*                autocomplete: "new-password",*/}
                            {/*            }}*/}
                            {/*            type="text"*/}
                            {/*            id={'title'}*/}
                            {/*            label={t("title")}*/}
                            {/*            disabled={mode === 'Preview'}*/}
                            {/*            variant="standard"*/}
                            {/*            fullWidth*/}
                            {/*            required*/}
                            {/*            {...register("title")}*/}
                            {/*            error={!!errors?.title}*/}
                            {/*            InputLabelProps={{shrink: true}}*/}
                            {/*        />*/}
                            {/*        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.title?.message}</FormHelperText>*/}
                            {/*    </FormControl>*/}
                            {/*</MDBox>*/}
                            {/*<MDBox mb={2}>*/}
                            {/*    <FormControl*/}
                            {/*        error = {!!errors.fullName}*/}
                            {/*        fullWidth*/}
                            {/*        focused = {true}*/}
                            {/*    >*/}
                            {/*        <MDInput*/}
                            {/*            inputProps={{*/}
                            {/*                autocomplete: "new-password",*/}
                            {/*            }}*/}
                            {/*            type="text"*/}
                            {/*            label={t("Full Name")}*/}
                            {/*            variant="standard"*/}
                            {/*            fullWidth*/}
                            {/*            required*/}
                            {/*            disabled={mode === 'Preview'}*/}
                            {/*            {...register("fullName")}*/}
                            {/*            error={!!errors?.fullName}*/}
                            {/*            InputLabelProps={{shrink: true}}*/}
                            {/*        />*/}
                            {/*        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.fullName?.message}</FormHelperText>*/}
                            {/*    </FormControl>*/}
                            {/*</MDBox>*/}
                            <MDBox mb={2}>
                                <FormControl
                                    error = {!!errors.firstName}
                                    fullWidth
                                    focused = {true}
                                >
                                    <MDInput
                                        inputProps={{
                                            autocomplete: "new-password",
                                        }}
                                        type="text"
                                        label={t("CustomerPage.First Name")}
                                        variant="standard"
                                        fullWidth
                                        required
                                        disabled={mode === 'Preview'}
                                        {...register("firstName")}
                                        error={!!errors?.firstName}
                                        InputLabelProps={{shrink: true}}
                                    />
                                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.firstName?.message}</FormHelperText>
                                </FormControl>
                            </MDBox>
                            <MDBox mb={2}>
                                <FormControl
                                    error = {!!errors.lastName}
                                    fullWidth
                                    focused = {true}
                                >
                                    <MDInput
                                        inputProps={{
                                            autocomplete: "new-password",
                                        }}
                                        type="text"
                                        label={t("CustomerPage.Last Name")}
                                        variant="standard"
                                        fullWidth
                                        required
                                        disabled={mode === 'Preview'}
                                        {...register("lastName")}
                                        error={!!errors?.lastName}
                                        InputLabelProps={{shrink: true}}
                                    />
                                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.lastName?.message}</FormHelperText>
                                </FormControl>
                            </MDBox>
                            <MDBox mb={2}>
                                <FormControl
                                    error = {!!errors.email}
                                    fullWidth
                                    // required
                                >
                                    <MDInput
                                        inputProps={{
                                            autocomplete: "new-password",
                                        }}
                                        type="email"
                                        label={t("Email")}
                                        variant="standard"
                                        fullWidth
                                        // required
                                        disabled={mode === 'Preview'}
                                        {...register("email")}
                                        error={!!errors?.email}
                                        InputLabelProps={{shrink: true}}
                                    />
                                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.email?.message}</FormHelperText>
                                </FormControl>

                            </MDBox>

                            <MDBox mb={2}>
                                <PlacesAutocomplete
                                    value={address}
                                    onChange={setAddress}
                                    onSelect={handleSelect}
                                    searchOptions={{
                                        language:languageSelect ==='zh'?'zh':'en',
                                        types: addressFilter,
                                        fields:["address_components"],
                                        // componentRestrictions: {
                                        //     country: ['us','ca','cn'],
                                        // },
                                    }}
                                    debounce={200}
                                >
                                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                        <FormControl
                                            error = {!!errors.address1}
                                            fullWidth
                                            required
                                            focused = {true}
                                        >
                                            <MDInput
                                                {...getInputProps()}
                                                type="text"
                                                label={t('SignUpPage.Address 1')}
                                                inputProps={{
                                                    autocomplete: "new-password",
                                                }}
                                                variant="standard"
                                                fullWidth
                                                required
                                                InputLabelProps={{shrink: true}}
                                                disabled={mode === 'Preview'}
                                            />
                                            <FormHelperText sx={{fontWeight:'medium'}}>{errors?.address1?.message}</FormHelperText>
                                            <div>
                                                {loading && <div style={{fontSize:'small'}}>Loading...</div>}
                                                {suggestions.map((suggestion,index )=> (
                                                    <div {...getSuggestionItemProps(suggestion)}>
                                <span
                                    onMouseEnter={() => handleMouseEnter(index)}
                                    onMouseLeave={handleMouseLeave}
                                    style={{fontSize:'small',cursor:'pointer',fontStyle: index === hoverSelect?'italic' : 'normal'}}
                                >{suggestion.description}</span>
                                                    </div>
                                                ))}
                                            </div>
                                        </FormControl>

                                    )

                                    }

                                </PlacesAutocomplete>

                            </MDBox>
                            <MDBox mb={2}>
                                <FormControl
                                    error = {!!errors.address2}
                                    fullWidth
                                    focused = {true}
                                >
                                    <MDInput
                                        type="text"
                                        id={'address2'}
                                        inputProps={{
                                            autocomplete: "new-password",
                                        }}
                                        label={t('SignUpPage.Apartment, unit, suite, or floor #')}
                                        variant="standard"
                                        fullWidth
                                        {...register("address2")}
                                        error={!!errors?.address2}
                                        InputLabelProps={{shrink: true}}
                                        disabled={mode === 'Preview'}
                                    />
                                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.address2?.message}</FormHelperText>
                                </FormControl>
                            </MDBox>
                            <MDBox mb={2}>
                                <FormControl
                                    error = {!!errors.city}
                                    fullWidth
                                    focused = {true}
                                    required
                                >
                                    <MDInput
                                        type="text"
                                        label={t('SignUpPage.City')}
                                        inputProps={{
                                            autocomplete: "new-password",
                                        }}
                                        variant='standard'
                                        fullWidth
                                        required
                                        name='city'
                                        value={cityValue}
                                        onChange={(event)=>setCityValue(event.target.value)}
                                        error={!!errors?.city}
                                        InputLabelProps={{shrink: true}}
                                        disabled={mode === 'Preview'}
                                    />
                                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.city?.message}</FormHelperText>
                                </FormControl>
                            </MDBox>

                            <MDBox mb={2}>
                                <FormControl
                                    error = {!!errors.province}
                                    fullWidth
                                    required
                                >
                                    <MDInput
                                        type="text"
                                        label={t('SignUpPage.State/Province')}
                                        variant='standard'
                                        inputProps={{
                                            autocomplete: "new-password",
                                        }}
                                        fullWidth
                                        required
                                        name='province'
                                        value={provinceValue}
                                        InputLabelProps={{shrink: true}}
                                        onChange={(event)=>setProvinceValue(event.target.value)}
                                        error={!!errors?.province}
                                        disabled={mode === 'Preview'}
                                    />
                                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.province?.message}</FormHelperText>
                                </FormControl>
                            </MDBox>
                            <Grid container mb={2} display="flex" xs={12} spacing={2}>
                                <Grid item xs={6} mb={2}>
                                    <FormControl
                                        error = {!!errors.postcode}
                                        fullWidth
                                        required
                                    >
                                        <MDInput
                                            type="text"
                                            label={t('SignUpPage.Postal Code')}
                                            inputProps={{
                                                autocomplete: "new-password",
                                            }}
                                            variant='standard'
                                            fullWidth
                                            required
                                            name='postcode'
                                            InputLabelProps={{shrink: true}}
                                            value={postcodeValue}
                                            onChange={(event)=>setPostcodeValue(event.target.value)}
                                            error={!!errors?.postcode}
                                            disabled={mode === 'Preview'}
                                        />
                                        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.postcode?.message}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} mb={2}>
                                    <FormControl fullWidth required error={!!errors?.countryObj} autoComplete="off" >
                                        <Autocomplete
                                            disabled={mode === 'Preview'}
                                            sx={{'& .MuiAutocomplete-inputRoot':{padding:0.05}}}
                                            required
                                            {...register('countryObj')}
                                            disablePortal={true}
                                            options={
                                                countriesForAddressList
                                            }
                                            getOptionLabel={(option) => `${option?.label} - ${option?.value} `}
                                            isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                            value={countryObj}
                                            onChange={(e, v) => {
                                                if (v) {
                                                    clearErrors("countryObj")
                                                }
                                                setCountryObj(v)
                                            }}
                                            renderInput={(params) =>
                                                <MDInput
                                                    autoComplete="off" // 添加这一行
                                                    required
                                                    {...register('countryObj')}
                                                    {...params}
                                                    label={t('SignUpPage.Country')}
                                                    InputLabelProps={{shrink: true}}
                                                    // error={!!errors?.countryObj}
                                                    variant={'standard'}
                                                />}
                                        />
                                        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.countryObj?.message}</FormHelperText>
                                    </FormControl>

                                </Grid>

                            </Grid>

                            <Grid item xs={12} mb={2} sx={{display: 'flex',alignItems: 'center'}}>
                                <FormControl
                                    error = {!!errors.phoneNumber}
                                    fullWidth
                                    required={true}
                                >
                                    <MuiPhoneNumber
                                        fullWidth
                                        defaultCountry='ca'
                                        label={t('SignUpPage.Phone Number')}
                                        required={true}
                                        value={phone}
                                        onChange={(value)=>setPhone(value)}
                                        disabled={mode === 'Preview'}
                                        sx={{
                                            '& .MuiInputAdornment-root': {
                                                pointerEvents: mode === 'Preview' ? 'none' : 'auto', // 禁用点击事件
                                            },
                                        }}
                                    />
                                    <FormHelperText sx={{fontWeight:'medium'}}>{errors?.phoneNumber?.message}</FormHelperText>
                                </FormControl>
                                {
                                    mode !== 'Preview' &&
                                    <MDBox>
                                        <Tooltip title={t("CustomerPage.You can change the phone country code by clicking on the flag icon")}>
                                            <IconButton>
                                                <InfoIcon/>
                                            </IconButton>
                                        </Tooltip>
                                    </MDBox>
                                }
                            </Grid>

                            <Grid container mb={2} display="flex" xs={12} spacing={1} justifyContent={'space-between'}>
                                <Grid item xs={6}>
                                    <FormControl
                                        error = {!!errors.phoneNumber2}
                                        fullWidth
                                    >
                                        <MDInput
                                            type="text"
                                            id={'phoneNumber2'}
                                            label={t('CustomerPage.Alternate Phone Number')}
                                            variant="standard"
                                            fullWidth
                                            {...register("phoneNumber2")}
                                            error={!!errors?.phoneNumber2}
                                            InputLabelProps={{shrink: true}}
                                            disabled={mode === 'Preview'}
                                        />
                                        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.phoneNumber2?.message}</FormHelperText>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl
                                        error = {!!errors.fax}
                                        fullWidth

                                    >
                                        <MDInput
                                            type="text"
                                            id={'fax'}
                                            label={t("CustomerPage.Contact Fax")}
                                            variant="standard"
                                            fullWidth
                                            {...register("fax")}
                                            error={!!errors?.fax}
                                            InputLabelProps={{shrink: true}}
                                            disabled={mode === 'Preview'}
                                        />
                                        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.fax?.message}</FormHelperText>
                                    </FormControl>
                                </Grid>

                            </Grid>

                            <MDBox>
                                <Grid item xs={12} mb={2}>
                                    <FormControl
                                        error = {!!errors.remark}
                                        fullWidth
                                    >
                                        <MDInput
                                            label={t("Remark")}
                                            variant="standard"
                                            fullWidth
                                            {...register("remark")}
                                            error={!!errors?.remark}
                                            InputLabelProps={{shrink: true}}
                                            disabled={mode === 'Preview'}
                                        />
                                        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.remark?.message}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </MDBox>
                            <MDBox>
                                <Grid item xs={12} >
                                    <FormControl
                                        error = {!!errors.remark}
                                        fullWidth
                                        required
                                    >

                                        <FormHelperText sx={{fontWeight:'medium'}}>{errors?.remark?.message}</FormHelperText>
                                    </FormControl>
                                </Grid>
                            </MDBox>
                            <Grid container mb={2} display="flex" xs={12} spacing={2} alignItems={'center'}>
                                <Grid item>
                                    <MDTypography variant='button'>{t('CustomerPage.Is Default')}</MDTypography>
                                </Grid>
                                <Grid item>

                                    <Checkbox
                                        size={'small'}
                                        disabled={mode === 'Preview'}
                                        checked={isDefault}
                                        onChange={(event) => {
                                            setIsDefault(event.target.checked)}}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />

                                </Grid>
                            </Grid>




                        </MDBox>
                        <FramerFade isActive={activeStep === 1} delay={0}>
                            <Grid textAlign='center'>
                                <Icon style={darkMode?{color:'white'}:{color:'text'}}  fontSize={'large'}>account_circle</Icon></Grid>
                            <MDTypography variant={'h5'} align="center">Additional...</MDTypography>


                        </FramerFade>
                    </MDBox>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <MDButton variant={'outlined'} color="primary" onClick={handleClearAll}>{t('Cancel')}</MDButton>
                {mode !=='Preview' && <MDButton variant={'contained'} color="primary" type={'submit'} >{t('Submit')}</MDButton>}
            </DialogActions>
        </MDBox>

    </Dialog>)
}

export default AddressAdd